// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__SQhIO","content":"Modal_content__vP6CM"};